import script from "./SupportPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPopup.vue?vue&type=script&setup=true&lang=js"

import "./SupportPopup.vue?vue&type=style&index=0&id=a76ed75e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76ed75e"]])

export default __exports__